var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Components/Button/Icon/Icon Only") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components/Button/Icon/Icon-Only",
    transform: "translate(-16.477612, -16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.500112, 16.833333)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59855633,0.1865655 L0.181889659,6.71989883 C0.161027873,6.74113992 0.142110083,6.76340681 0.122619196,6.78965011 L0.0814609884,6.85416796 L0.0516174914,6.91447557 L0.0222820536,6.9995144 L0.0127664884,7.0386697 L0.00269800341,7.10883023 L3.55271368e-15,7.16053742 C3.55271368e-15,7.22954521 0.00898323158,7.29145354 0.0266435723,7.35030867 L0.0549150932,7.42600584 L0.0955627452,7.50307628 C0.124630361,7.54885532 0.151544568,7.58253768 0.181889659,7.6134345 L6.59855633,14.1467678 L6.65883734,14.20035 C6.91626068,14.3953992 7.26456853,14.3707526 7.4845536,14.1467678 L7.53714681,14.0854268 L7.58363193,14.0125206 C7.72101596,13.763131 7.68321358,13.4555042 7.4845536,13.2532322 L2.12922163,7.8 L14.3748883,7.8 L14.4484711,7.79535025 C14.7683867,7.7515597 14.9998883,7.48378393 14.9998883,7.16666667 L14.9956931,7.09292958 C14.9596703,6.77839927 14.6960411,6.53333333 14.3748883,6.53333333 L2.12788829,6.53333333 L7.48454942,1.08010542 L7.53714681,1.01876018 C7.72696786,0.759043191 7.70307958,0.409064683 7.4845536,0.1865655 C7.24024163,-0.0621884999 6.84286829,-0.0621884999 6.59855633,0.1865655 Z",
    id: "Icon-Color"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.78997e6b0e3cb83d447782b41da0d415.svg";
export { ForwardRef as ReactComponent };